import React, { FunctionComponent, useCallback } from 'react';

import { useNavigate } from '@reach/router';

import { withPrefix } from 'gatsby';
import SearchForm, { SearchFormProps } from 'src/components/SearchForm';
import searchTracking from 'src/tracking/search';
import createPath from 'src/utils/create-path';

export interface SearchFormWithNavigationProps extends Omit<SearchFormProps, 'onSearch'> {
  radius?: number;
}

const SearchFormWithNavigation: FunctionComponent<SearchFormWithNavigationProps> = (props) => {
  const { radius, ...other } = props;
  const navigate = useNavigate();

  const handleSearch: SearchFormProps['onSearch'] = useCallback(
    (keyword, city) => {
      const path = createPath({ keyword, city, radius, type: 'search' });
      navigate(withPrefix(path));
      searchTracking.submitJobSearch();
    },
    [navigate, radius]
  );

  return <SearchForm onSearch={handleSearch} {...other} />;
};

export default SearchFormWithNavigation;
